import { gql } from '@apollo/client';

export const LOGIN = gql`
  mutation login($input: LoginInput!) {
    login(input: $input) {
      access_token
      refresh_token
      expires_in
    }
  }
`;

export const GET_ME = gql`
  query me {
    me {
      uuid
      login
      first_name
      middle_name
      last_name
      phone
      is_owner
      permissions {
        alias
      }
      roles {
        alias
        id
        permissions {
          alias
          id
        }
      }
      avatar_url
    }
  }
`;

export const START_WORK_SHIFT = gql`
  mutation startWorkShift($input: StartWorkShiftInput!) {
    startWorkShift(input: $input) {
      id
    }
  }
`;

export const FINISH_WORK_SHIFT = gql`
  mutation finishWorkShift(
    $input: FinishWorkShiftInput!
    $confirm_pass: String!
  ) {
    finishWorkShift(input: $input, confirm_pass: $confirm_pass) {
      id
    }
  }
`;

export const FORCE_FINISH_WORK_SHIT = gql`
  mutation forceFinishWorkShift($input: FinishWorkShiftInput!) {
    forceFinishWorkShift(input: $input) {
      id
    }
  }
`;

export const USER_CLUBS = gql`
  query userClubs($input: UserClubsInput) {
    userClubs(input: $input) {
      id
      name
      address
      workShiftStatus
      permitted
      tariffName
      operatorLastName
      operatorFirstName
    }
  }
`;

export const RELOGIN = gql`
  mutation relogin($id: Int!) {
    relogin(id: $id) {
      access_token
      refresh_token
      expires_in
    }
  }
`;

export const LOGOUT_ALL = gql`
  mutation LogoutAllV2 {
    logoutAll
  }
`;
